import { render } from "./AlarmList.vue?vue&type=template&id=732d55e4"
import script from "./AlarmList.vue?vue&type=script&lang=js"
export * from "./AlarmList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__